import AppProvider from "state";
import { Suspense } from "react";
import useAuth from "hooks/useAuth";
import PrivateApp from "./PrivateApp";
import LoadingPage from "components/LoadingPage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const RootApp = () => {
  const { isValid } = useAuth();

  const router = createBrowserRouter([
    {
      path: "*",
      element: (
        <Suspense fallback={<LoadingPage isLoading={true} />}>
          {isValid ? (
            <AppProvider>
              <PrivateApp />
            </AppProvider>
          ) : (
            <LoadingPage isLoading={true} />
          )}
        </Suspense>
      ),
    },
  ]);

  return <RouterProvider router={router} />;
};

export default RootApp;
